module.exports = __webpack_public_path__ + "48c4dc9db13c355b74735a133ce91cfa.svg";